module.exports = __webpack_public_path__ + "img/IMM.aa4c019a.jpeg";